<template>
  <div class="investment_warp">
    <SearchHunt
      :filterData="filterData"
      @handle_seach="handle_seach"
      @handle_add="handle_add(null,1)"
      ref="SearchHunt"
    />
    <a-table
      class="antd-table"
      bordered
      :columns="relevanceBatch_grid.field"
      :data-source="relevanceBatch_grid.row"
      rowKey="id"
      size="small"
      :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
      :pagination="false"
      :loading="tableLoading"
    >
      <!-- 序号 -->
      <div slot="index" slot-scope="text, record, index">
        {{ index + (pageParam.pageNum - 1) * pageParam.pageSize + 1 }}
      </div>
      <!-- 图例 -->
      <span slot="imgUrl" slot-scope="text, record">
        <img
          v-if="record.pictList.length > 0"
          style="height: 50px;max-width: 100%; margin-right: 4px"
          :src="url + record.pictList[0].id"
          @click="handleImg(record.pictList[0].id)"
        />
      </span>
      <!-- 服务状态 -->
      <span slot="status" slot-scope="text, record">
        <span v-if="record.status == '01'"><a-badge color="cyan" /></span>
        <span v-else-if="record.status == '02'"><a-badge color="red"/></span>
        {{ record.status | DictionaryFilter("COMMONSTATUS") }}
      </span>
      <!-- 更多操作 -->
      <span slot="operation" slot-scope="data" class="ellipsis">
        <a @click="handle_add(data,2)">编辑</a>
        <a @click="handle_detele(data)">删除</a>
        <!-- <a @click="moveUp(data,1)">上移</a>
        <a @click="moveUp(data,2)">下移</a> -->
      </span>
    </a-table>

    <!-- 底部 -->
    <div class="table_bottom">
      <!-- 按钮 -->
      <!-- <div class="bottom_btn">
        <a-button type="primary" @click="handle_all" class="btn_first">选择全部</a-button>
        <a-button type="primary" ghost  @click="handle_reverse">反向选择</a-button>
      </div> -->

      <!-- 分页 -->
      <div>
        <a-pagination
          class="table_pagination"
          show-size-changer
          :default-current="1"
          v-model="pageParam.pageNum"
          :show-total="(total) => `共 ${total} 条`"
          :page-size-options="pageSizeOptions"
          size="small"
          :total="total"
          @showSizeChange="onShowSizeChange"
          @change="paginationChange"
          :page-size.sync="pageParam.pageSize"
        />
      </div>
    </div>

    <!-- 表单 -->
    <!-- 添加 -->
    <addModal
      v-if="addVisible"
      :modalTitle="modalTitle"
      :addId="addId"
      :data="addData"
      @close="close" 
      @handleOk="addlHandleOk"
    ></addModal>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancelImg"
      class="imgBox"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import {
  queryAppMenu,
  deleteMenuById,
  sortById,
  getId,
  backMenuAdd,
  updateMenu,
  queryAppById
} from "@/api/api.js";
import moment from "moment";
import SearchHunt from "./components/search-hunt/search-hunt.vue";
import addModal from "./components/modal-hunt/add-modal.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "",
  components: {
    SearchHunt,
    addModal
  },
  data() {
    return {
      //搜索栏
      filterData: [
        {
          name: "goodName",
          type: "input",
          value: undefined,
          label: "请输入绑定商品名称",
          placeholder:"绑定商品名称：",
        },
        {
          name: "title",
          type: "input",
          value: undefined,
          label: "请输入标题",
          placeholder:"标题：",
        },
      ],
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 40,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "绑定商品名称",
            colSpan: 1,
            width: 160,
            dataIndex: "goodsName",
            align: "center",
            ellipsis: true,
          },
          {
            title: "标题",
            align: "center",
            width: 160,
            dataIndex: "title",
            ellipsis: true,
          },
          {
            title: "图例",
            align: "center",
            width: 160,
            dataIndex: "imgUrl",
            ellipsis: true,
            scopedSlots: {
              customRender: "imgUrl",
            },
          },
          {
            title: "URL链接",
            colSpan: 1,
            align: "center",
            width: 170,
            ellipsis: true,
            dataIndex: "urlAddress",
            scopedSlots: {
              customRender: "urlAddress",
            },
          },
          {
            title: "显示顺序",
            align: "center",
            width: 60,
            dataIndex: "menuOrder",
            ellipsis: true,
          },
          {
            title: "服务状态",
            colSpan: 1,
            align: "center",
            width: 60,
            ellipsis: true,
            dataIndex: "status",
            scopedSlots: {
              customRender: "status",
            },
          },
          {
            title: "操作",
            width: 80,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      paramsObj: {
        goodName: null,
        title: null
      },
      list: [],
      selectedRows: [],//多选数据
      //添加弹窗
      addVisible: false,
      modalTitle: "",
      addData:{},

      //图片
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      previewVisible: false,
      previewImage: "",

      //新增id
      addId: "",

      //查询加载
      tableLoading:false,

      
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["COMMONSTATUS"]).then((res) => {
      //查询
      this.queryList();
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      queryAppMenu({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      })
      .then((res) => {
        if (res.content.rows && res.content.rows.length) {
          this.relevanceBatch_grid.row = res.content.rows;
          this.total = res.content.page.totalRows;
        } else {
          this.relevanceBatch_grid.row = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }, (err) => {
        this.tableLoading = false;
      });
    },
    //添加
    handle_add(data, type) {
      if (type == 1) {
        getId().then((res) => {
          this.addId = res.content.id;
          this.modalTitle = "添加",
          this.addVisible = true;
        })
      } else {
        //查询接口
        queryAppById({
          id: data.id,
        }).then((res) => {
          if (res.code == '0000') {
            this.addData = res.content;
            this.addId = data.id;
            this.modalTitle = "编辑",
            this.addVisible = true;
          }
         });
      }
    },
    //删除
    handle_detele(data) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        cancelType:"primary",
        onOk: () => {
          deleteMenuById({
            id: data.id
          }).then(res => {
            this.$message.success("操作成功！");
            this.pageParam.pageNum = 1;
            this.queryList();
          });
        },
        onCancel: () => {},
      });
    },
    //弹窗关闭
    close() {
      this.addVisible = false;
    },
    //添加弹窗确认
    addlHandleOk(data, title) {
      if (title == "添加") {
        //新增
        backMenuAdd({
          goodId: data.goodId,
          id: data.id,
          menuNo: data.menuNo,
          menuOrder: data.menuOrder,
          status: data.status,
          title: data.title,
          urlAddress: data.urlAddress
        }).then(
          (res) => {
            if (res.code == '0000') {
              this.$message.success('新增成功！');
              this.addVisible = false;
              this.queryList();
            }
          },
          (err) => {
            this.$message.error('新增失败！');
            this.addVisible = false;
          }); 
      } else if (title == "编辑") {
        //编辑
        updateMenu({
          goodId: data.goodId,
          id: data.id,
          menuOrder: data.menuOrder,
          status: data.status,
          title: data.title,
          urlAddress: data.urlAddress
        }).then(
          (res) => {
            if (res.code == '0000') {
              this.$message.success('编辑成功！');
              this.addVisible = false;
              this.queryList();
            }
          },
          (err) => {
            this.$message.error('编辑失败！');
            this.addVisible = false;
          }); 
      }
    },
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.previewImage = this.url + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    //上移
    moveUp(data,direction) {
      sortById({
        id: data.id,
        direction:direction,
      }).then(
        (res) => {
          this.$message.success("操作成功！");
          this.queryList();
      },
      (err) => {
        this.$message.error("操作失败！");
      });
    }
  },
};
</script>

<style scoped lang="less">
.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{

  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }
}
</style>